<div *ngIf="isEdit else dataForm">
<div bsModal
       #staticModal="bs-modal"
       class="modal fade"
       tabindex="-1"
       role="dialog"
       aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" translate>CONTRACT_DUPLICATE_MODAL_TITLE</h4>
        </div>
        <div class="modal-body">
          <div class="portlet-body modal-body-min-h">
            <form [formGroup]="myForm">
              <div class="textInput">
                  <storever-element-group
                    [icon]="'fa-address-book'"
                    [title]="'none'"
                    [config]="formConfig.config"
                    [form]="myForm">
                  </storever-element-group>
              </div>
            </form>
            <br>
            <div class="help-block error error-msg-padding" *ngIf="error !== 'false'">{{error}}</div>
<!--            <div class="help-block error error-msg-padding" *ngIf="errorName !== 'false'">{{errorName}}</div>-->
          </div>
        </div>
        <br>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" [disabled]="myForm.invalid || errorName !== 'false' || error !== 'false' "
                  (click)="send(myForm.value)"> {{'CONTRACT_DUPLICATE_MODAL_BTN' | translate:locale.language}} </button>
          <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
        </div>
      </div>
    </div>
</div>
</div>
  <!--this template is used when we call this modal via data table-->
  <ng-template #dataForm >
    <div class="modal-header" >
      <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title" translate>CONTRACT_DUPLICATE_MODAL_TITLE</h4>
    </div>
    <div class="modal-body" >
      <div class="portlet-body modal-body-min-h">
        <form [formGroup]="myForm" >
          <div class="textInput">
              <storever-element-group
                [icon]="'fa-address-book'"
                [title]="'none'"
                [config]="formConfig.config"
                [form]="myForm">
              </storever-element-group>
          </div>
        </form>
        <br>
<!--        <div class="help-block error error-msg-padding" *ngIf="error !== 'false'">{{error}}</div>-->
<!--        <div class="help-block error error-msg-padding"    *ngIf="errorName !== 'false'">{{errorName}}</div>-->
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="myForm.invalid || errorName !== 'false'"
              (click)="send(myForm.value)"> {{'CONTRACT_DUPLICATE_MODAL_BTN' | translate:locale.language}} </button>
      <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
    </div>
  </ng-template>




